import React from 'react'
import {Link} from 'react-router-dom'

const PageLoad = () => {
  const [isLoadingLong, setIsLoadingLong] = React.useState(false)
  const [isLoadingLonger, setIsLoadingLonger] = React.useState(false)
  const [isLoadingLongest, setIsLoadingLongest] = React.useState(false)
  const [isLoadingUnexpectedLong, setIsLoadingUnexpectedLong] = React.useState(false)

  React.useEffect(() => {
    const timerLong = setTimeout(() => setIsLoadingLong(true), 1500)
    const timerLonger = setTimeout(() => setIsLoadingLonger(true), 5000)
    const timerLongest = setTimeout(() => setIsLoadingLongest(true), 18000)
    const timerUnexpectedLong = setTimeout(() => setIsLoadingUnexpectedLong(true), 35000)

    return () => {
      clearTimeout(timerLong)
      clearTimeout(timerLonger)
      clearTimeout(timerLongest)
      clearTimeout(timerUnexpectedLong)
    }
  }, [])

  if (isLoadingUnexpectedLong) {
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container tw:text-center">
            <div className="columns is-centered">
              <div className="column is-6">
                <h1 className="title is-4">Not sure what's happening...</h1>
                <span className="icon is-large">
                  <i className="fa-solid fa-3x fa-plug" />
                </span>

                <p className="tw:mt-4">
                  Maybe someone pulled the wrong plug? Stay tuned, the asset should come in a second.
                </p>
                <progress className="progress is-info is-small tw:mt-4" />
                <Link className="button" to="/">
                  Or go back to Start
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (isLoadingLongest) {
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container tw:text-center">
            <div className="columns is-centered">
              <div className="column is-6">
                <h1 className="title is-4">Don't drink too much...</h1>
                <span className="icon is-large">
                  <i className="fa-solid fa-3x fa-mug-hot" />
                </span>

                <p className="tw:mt-4">...we do not want to be responsible for drowing in coffee!</p>
                <progress className="progress is-info is-small tw:mt-4" />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (isLoadingLonger) {
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container tw:text-center">
            <div className="columns is-centered">
              <div className="column is-6">
                <h1 className="title is-4">Just take another sip...</h1>
                <span className="icon is-large">
                  <i className="fa-solid fa-3x fa-mug-hot" />
                </span>

                <p className="tw:mt-4">...before your transparency journey continues!</p>
                <progress className="progress is-info is-small tw:mt-4" />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (isLoadingLong) {
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container tw:text-center">
            <div className="columns is-centered">
              <div className="column is-6">
                <progress className="progress is-info is-small tw:mt-4" />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  return null
}
export default PageLoad
